import { useEffect, useState } from "react";

const canMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

/**
 * Tracks a media query, tolerating environments without matchMedia (jsdom,
 * and any SSR pass) rather than throwing during render.
 *
 * The first render already has the answer: starting at `false` and correcting
 * it in an effect drew a wide layout on a phone for one frame, and anything
 * that fetched by layout fetched twice.
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(
    () => canMatchMedia() && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (!canMatchMedia()) {
      return undefined;
    }

    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const onChange = (event) => setMatches(event.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
};
